import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-site-search',
  templateUrl: './site-search.component.html',
  styleUrls: ['./site-search.component.scss']
})
export class SiteSearchComponent implements OnInit {

  searhPhase: string ="";
  searchData: any = [];

  citeLoader = false;
  citeRepat: any[] = [1,2,3,4,5,6,7,8,9,10];

  constructor(
    private _info: InfoApiService,
    private _actRoute: ActivatedRoute,
    private seo: SeoService
  ) { }

  ngOnInit(): void {
    this._actRoute.paramMap.subscribe(params => {
      this.searhPhase = this._actRoute.snapshot.params.phase;
      this.siteSearch(this.searhPhase);
    });
    this.seo.setMeta('Search '+this.searhPhase)

  }

  // Get all information data
  siteSearch(phase: string){
    this.citeLoader = true;
    this._info.siteSearch(phase).subscribe (
      (response: HssResponse<any>) => {
        this.searchData = response.body;
        this.citeLoader = false;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
}
